<section scId="SC1036" *ngIf="pdpStaticContent">
  <div *ngIf="isOnlyDevice">
    <tmo-junk-fee-banner [aemContent]="pdpStaticContent"></tmo-junk-fee-banner>
  </div>
  <tmo-change-entry
    [aemContent]="pdpStaticContent"
    (browseEntryChange)="navigateHome()"
  ></tmo-change-entry>
  <tmo-page-titles [pageTitle]="productDetailTitle"></tmo-page-titles>
  <ng-container *ngIf="productDetails; else displayNoOffersFound">
    <tmo-container-holder [isDynamicContent]="pdpAuthorableData"></tmo-container-holder>
  </ng-container>
  <ng-template #displayNoOffersFound>
    <div class="m-t-lg" *ngIf="!isProductAvailable">
      {{ pdpStaticContent?.zipCodeErrorMessage }}
    </div>
  </ng-template>
</section>
<tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
